interface OptionalLabelProps {
  label: string;
}
export default function OptionalLabel({ label }: OptionalLabelProps) {
  return (
    <span>
      {label} <span className="secondary">(optional)</span>
    </span>
  );
}
